
/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 21/02/2025
 * @update 21/02/2025
 * @file src/components/W17/W17F3102
 */

import Api from "../../../services/api";

export function loadCboFilterMonth(cb) {
    return () => {
        Api.get('/w17f3102/load-cbo-filter-month')
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadCboEmployee(cb) {
    return () => {
        Api.get('/w17f3102/load-cbo-employee')
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadForm(param, cb) {
    return async () => {
        Api.put('/w17f3102/load-form', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function onExport(params, cb) {
    return async () => {
        Api.put('/w17f3102/export', params)
            .then(result => {
                console.log(result,'===========>',result.ok);
                
                if (result && result.ok) {
                    // let _res = null;
                    // if (response.type === "json") {
                    //     _res = yield response.data.json();
                    //     if (_res && _res.data) {
                    //         cb && cb(null, _res.data);
                    //     } else {
                    //         cb && cb(_res, null)
                    //     }
                    // } else {
                    //     const content = yield response.data.blob();
                    //     const datetime = new Date().getTime();
                    //     const _fileName = response.filename ? checkUrlFileName(response.filename) : "data-export-crm-" + datetime + '.xls';
                    //     _res = {
                    //         fileName: _fileName,
                    //         fileExt: Config.helpers.getExtFile(_fileName),
                    //         URL: URL.createObjectURL(content),
                    //     };
                    //     if (_res && _res.URL) {
                    //         cb && cb(null, _res);
                    //     } else {
                    //         cb && cb(_res, null);
                    //     }
                    // }
                }
                else {
                    cb && cb(result, null)
                }
            });
    };
}
